import { read, utils } from "xlsx";
import { type ParseResult } from "papaparse";

/**
 * Excelファイルを読み込む
 * @param file Excelファイル
 * @return CSVパース結果と同じ形式のオブジェクト
 */
export const readExcel = async (file: File): Promise<ParseResult<unknown>> =>
  await new Promise<ParseResult<unknown>>((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener("error", () => {
      reject(reader.error);
    });
    reader.addEventListener("load", () => {
      try {
        const { result: arrayBuffer } = reader;
        if (!(arrayBuffer instanceof ArrayBuffer)) {
          reject(new Error("ファイルの読み込みに失敗しました"));
          return;
        }

        const workbook = read(arrayBuffer, { type: "array" });

        if (!workbook.SheetNames || workbook.SheetNames.length === 0) {
          reject(new Error("Excelファイルにシートが含まれていません"));
          return;
        }

        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = utils.sheet_to_json(worksheet, { header: 1 });

        const filteredData = jsonData.filter(
          (row: unknown) =>
            Array.isArray(row) &&
            row.some(
              (cell: unknown) =>
                cell !== null && cell !== undefined && cell !== ""
            )
        );

        if (filteredData.length === 0) {
          reject(new Error("ファイルにデータが含まれていません"));
          return;
        }

        const headers = filteredData[0] as string[];
        const data = filteredData.slice(1).map((row: unknown) => {
          const rowArray = row as unknown[];
          const rowObj: Record<string, string> = {};
          headers.forEach((header, index) => {
            rowObj[header] =
              rowArray[index] != null ? String(rowArray[index]) : "";
          });
          return rowObj;
        });

        const parseResult: ParseResult<unknown> = {
          data,
          errors: [],
          meta: {
            delimiter: "",
            linebreak: "",
            aborted: false,
            truncated: false,
            cursor: 0,
            fields: headers,
          },
        };

        resolve(parseResult);
      } catch (error) {
        reject(error);
      }
    });
    reader.readAsArrayBuffer(file);
  });
